import { render } from "./UserAssignedTool.vue?vue&type=template&id=f9d282c2&scoped=true&ts=true&lang=pug"
import script from "./UserAssignedTool.vue?vue&type=script&lang=ts"
export * from "./UserAssignedTool.vue?vue&type=script&lang=ts"

import "./UserAssignedTool.vue?vue&type=style&index=0&id=f9d282c2&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9d282c2"]])

export default __exports__